export type ChatToolParameterType = 'string' | 'number' | 'boolean' | 'integer' | 'array' | 'object';

export const UPLOADED_FILES_ITEM_TYPE_REFERENCE = `[
  {
    name: string
    key: string
    mimeType: string
    size: number
    extension: string
    category: string
    base64: string
    url?: string | null
    customer_external_id?: string | null
    choices: [
      {
        label: string
        value: string
      }
    ]
  }
]
  
const { uploadedFiles } = args;`;

export interface ChatToolParameter {
  id: string;
  chatToolId: string;
  name: string;
  type: ChatToolParameterType;
  description?: string | null;
  enumValues?: string[] | null;
  isRequired: boolean;
  createdDate: string;
  updatedDate: string;
}

/** Prompt linked to a tool (returned on tool list/detail when available). */
export interface ChatToolLinkedPrompt {
  id: number;
  rootPromptId?: number;
  rule: string;
  /** Link order on the prompt lineage, when provided. */
  order?: number;
}

export interface ChatTool {
  id: string;
  name: string;
  description: string;
  code: string;
  isActive: boolean;
  parameters: ChatToolParameter[];
  /** Prompts that link this tool (read-only on Tools UI). */
  prompts?: ChatToolLinkedPrompt[];
  createdDate: string;
  updatedDate: string;
}

/** Replace-all body for `PUT /api/chat-tools/by-prompt/:promptId` and prompt `toolLinks`. */
export interface ChatPromptToolLink {
  toolId: number;
  order: number;
}

export interface ChatToolParameterInput {
  name: string;
  type: ChatToolParameterType;
  description?: string;
  enumValues?: string[];
  isRequired: boolean;
}

export interface ChatToolCreateRequest {
  name: string;
  description: string;
  code: string;
  isActive?: boolean;
  parameters?: ChatToolParameterInput[];
}

export interface ChatToolUpdateRequest {
  name?: string;
  description?: string;
  code?: string;
  isActive?: boolean;
  parameters?: ChatToolParameterInput[];
}

export interface ChatToolListResponse {
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  data: ChatTool[];
}

